import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export const Navigation = () => {
  const { user, logout, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="bg-primary-800 shadow-md">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Brand */}
          <Link
            to="/"
            className="flex items-center gap-2 text-white font-bold text-lg tracking-tight hover:text-primary-200 transition-colors"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25" />
            </svg>
            Padrón Electoral
          </Link>

          {/* Desktop nav */}
          {isAuthenticated && (
            <nav className="hidden sm:flex items-center gap-1">
              <Link
                to="/dashboard"
                className="rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
              >
                Dashboard
              </Link>
              {user?.role?.name === "referente" && (
                <Link
                  to="/form-submission"
                  className="rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
                >
                  Cargar Formulario
                </Link>
              )}
              {user?.role?.name === "secretaria" && (
                <Link
                  to="/admin"
                  className="rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
                >
                  Administración
                </Link>
              )}
              <div className="ml-4 flex items-center gap-3 border-l border-primary-700 pl-4">
                <span className="text-sm text-primary-200 font-medium">{user?.firstName}</span>
                <button
                  onClick={handleLogout}
                  className="rounded-md bg-primary-900/60 px-3 py-1.5 text-sm font-medium text-white hover:bg-primary-900 transition-colors"
                >
                  Cerrar Sesión
                </button>
              </div>
            </nav>
          )}

          {/* Mobile: hamburger */}
          {isAuthenticated && (
            <button
              className="sm:hidden rounded-md p-2 text-primary-100 hover:bg-primary-700 transition-colors"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="Abrir menú"
            >
              {menuOpen ? (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              )}
            </button>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      {isAuthenticated && menuOpen && (
        <div className="sm:hidden border-t border-primary-700 bg-primary-900 px-4 py-3 space-y-1">
          <p className="text-xs text-primary-400 font-semibold uppercase tracking-wider mb-2">
            {user?.firstName} {user?.lastName}
          </p>
          <Link
            to="/dashboard"
            onClick={() => setMenuOpen(false)}
            className="block rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
          >
            Dashboard
          </Link>
          {user?.role?.name === "referente" && (
            <Link
              to="/form-submission"
              onClick={() => setMenuOpen(false)}
              className="block rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
            >
              Cargar Formulario
            </Link>
          )}
          {user?.role?.name === "secretaria" && (
            <Link
              to="/admin"
              onClick={() => setMenuOpen(false)}
              className="block rounded-md px-3 py-2 text-sm font-medium text-primary-100 hover:bg-primary-700 hover:text-white transition-colors"
            >
              Administración
            </Link>
          )}
          <button
            onClick={handleLogout}
            className="w-full mt-2 rounded-md bg-red-700 px-3 py-2 text-sm font-medium text-white hover:bg-red-800 transition-colors text-left"
          >
            Cerrar Sesión
          </button>
        </div>
      )}
    </header>
  );
};

